






































































































































import toastificationContent from "@/layouts/components/toastification/toastificationContent.vue";
import i18n from "@/libs/i18n";
import Luxon from "@/libs/luxon";
import { useApiKeysStore } from "@/store/useApiKeysStore";
import { ApiKey } from "@/types/apiKey.types";
import { formatDate, toRelative } from "@/utils/luxon";
import ApiStatus from "@/views/modules/settings/developers/components/apiStatus.vue";
import useApiKeys from "@/views/modules/settings/developers/useApiKeys";
import { defineComponent, ref, Ref } from "@vue/composition-api";
import {
    BAlert,
    BButton,
    BCol,
    BForm,
    BFormCheckbox,
    BFormDatepicker,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormText,
    BFormTextarea,
    BModal,
    BRow,
    BSpinner,
    BTable,
    VBTooltip,
} from "bootstrap-vue";
import { storeToRefs } from "pinia";
import { useToast } from "vue-toastification/composition";

export default defineComponent({
    components: {
        BFormDatepicker,
        BModal,
        BAlert,
        BFormCheckbox,
        BForm,
        BFormSelect,
        BFormInput,
        BFormText,
        BFormTextarea,
        BFormGroup,
        BButton,
        BRow,
        BCol,
        ApiStatus,
        BTable,
        BSpinner,
    },
    directives: {
        "b-tooltip": VBTooltip,
    },
    setup(_, { root }) {
        const toast = useToast();
        const { tableColumns, sortBy, isSortDirDesc, read } = useApiKeys();
        const { createApiKey, deleteApiKey } = useApiKeysStore();
        const { apiKeys, isLoadingApiKeys, isLoadingApiKey } = storeToRefs(useApiKeysStore());
        const showModal = ref(false);
        const showAlert = ref(false);
        const generatedApiKey: Ref<{ key?: string; hash?: string }> = ref({
            key: null,
            hash: null,
        });

        read();

        const apiKey: Ref<ApiKey> = ref({
            expiresAt: null,
        });

        const reset = () => {
            apiKey.value = {
                expiresAt: null,
            };
        };

        const createKey = () => {
            return createApiKey(apiKey.value)
                .then((res: ApiKey) => {
                    toast({
                        component: toastificationContent,
                        props: {
                            title: i18n.t("settings.developers.api-keys.api-keys"),
                            text: i18n.t("settings.developers.api-keys.api-key-created-success"),
                            icon: "check",
                            variant: "success",
                        },
                    });

                    generatedApiKey.value = {
                        key: res.key,
                        hash: res.hash,
                    };

                    showModal.value = false;
                    showAlert.value = true;

                    return res;
                })
                .catch((e) => {
                    toast({
                        component: toastificationContent,
                        props: {
                            title: i18n.t("settings.developers.api-keys.api-keys"),
                            text: i18n.t("settings.developers.api-keys.api-key-created-error"),
                            icon: "times",
                            variant: "error",
                        },
                    });

                    throw e;
                });
        };

        const deleteKey = (apiKeyId: number) => {
            root.$bvModal
                .msgBoxConfirm(i18n.t("confirm.Are you sure?"), {
                    title: i18n.t("confirm.Are you sure?"),
                    cancelTitle: i18n.t("confirm.Cancel"),
                    cancelVariant: "light",
                    okTitle: i18n.t("confirm.Yes, delete"),
                    hideHeaderClose: false,
                    headerCloseVariant: "light",
                    centered: true,
                    bodyClass: "mx-auto",
                    headerClass: "text-center",
                })
                .then((result) => {
                    if (result) {
                        return deleteApiKey(apiKeyId)
                            .then((res) => {
                                toast({
                                    component: toastificationContent,
                                    props: {
                                        title: i18n.t("settings.developers.api-keys.api-keys"),
                                        text: i18n.t("settings.developers.api-keys.api-key-deleted-success"),
                                        icon: "check",
                                        variant: "success",
                                    },
                                });

                                return res;
                            })
                            .catch(() => {
                                toast({
                                    component: toastificationContent,
                                    props: {
                                        title: i18n.t("settings.developers.api-keys.api-keys"),
                                        text: i18n.t("settings.developers.api-keys.api-key-deleted-error"),
                                        icon: "times",
                                        variant: "error",
                                    },
                                });
                            });
                    }
                });
        };

        const searchQuery = ref("");
        return {
            Luxon,
            apiKey,
            apiKeys,
            createKey,
            deleteKey,
            formatDate,
            generatedApiKey,
            isLoadingApiKey,
            isLoadingApiKeys,
            isSortDirDesc,
            reset,
            searchQuery,
            showAlert,
            showModal,
            sortBy,
            tableColumns,
            toRelative,
        };
    },
});
